import * as React from 'react';
import * as styles from './SummaryDesktop.css';
import { ActionButtonsContainer } from '../../../ActionButtons';
import { BalanceContainer } from '../../../Balance';
import { CheckoutContainer } from '../../../Checkout';
import { MLSNPublicationBannerContainer } from '../../../MLSNPublicationBanner';
import { N1PublicationBannerContainer } from '../../../N1PublicationBanner';
import { VisibleViolationsWarningContainer } from '../../../VisibleViolationsWarning';

export const SummaryDesktop = () => {
  return (
    <div>
      <N1PublicationBannerContainer />
      <MLSNPublicationBannerContainer />

      <div className={styles['container']}>
        <BalanceContainer />

        <div className={styles['checkout']}>
          <CheckoutContainer />
          <VisibleViolationsWarningContainer />
          <ActionButtonsContainer />
        </div>
      </div>
    </div>
  );
};
